<template>
    <div v-cloak>
        <v-card id="password" elevation="4" class="mb-8">
            <v-toolbar color="brown" dark flat dense>
                <v-toolbar-title>Your Password</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-scroll-to="'#top'" dark text>
                    <v-icon left>fas fa-chevron-up</v-icon>
                    Top
                </v-btn>
                <span v-scroll-to="'#kickers'" class="fa-stack fa-md icon-info">
                    <i class="fa fa-circle fa-stack-2x"></i>
                    <i class="fa fa-key fa-stack-1x"></i>
                </span>
            </v-toolbar>
            <v-card-text>
                <p class="text-h6">Need to change your password?</p>
                <p>The password you used to log into Onboarding is what you will use to log into College computers.</p>
                <p>If you would like to change this to something more memorable, you can reset you password by clicking below:</p>
                <p>For information on how to change your password, please click on the Change Password Guidance (Video) link below. </p>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="OpenPasswordReset" color="info" dark small style="color:white !important">
                    <v-icon left small>fas fa-key</v-icon>
                    Change Your Password
                </v-btn>
                <v-btn @click="OpenVideoGuidance" color="info" dark small style="color:white !important">
                    <v-icon left small>fas fa-info-circle</v-icon>
                    Change Password Guidance (Video)
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
    export default {
        methods: {
            OpenPasswordReset() { window.open('https://passwordreset.microsoftonline.com', '_blank'); },
            OpenVideoGuidance() { window.open('https://youtu.be/NuKgavdrDDo', '_blank'); }
        },
    }
</script>

<style>
    img.photo {
        border-radius: 5px;
        float: right;
        margin-left: 10px;
        max-width: 120px;
    }
</style>